import { hexTransparencies } from "~/styles/variables/hex-transparencies"

export function getColorWithOpacity(color: `#${string}`, opacity: keyof typeof hexTransparencies) {
  const hexOpacity = hexTransparencies[opacity]
  return `${color}${hexOpacity}`
}
